export enum AccordionClasses {
    Button = 'accordion__button',
    Content = 'accordion__content',
    ButtonActiveModifier = 'active'
}
